module.exports = __webpack_public_path__ + "img/download.84175284.svg";